import { render, staticRenderFns } from "./SidenavComponent.vue?vue&type=template&id=4e70b482&"
import script from "./SidenavComponent.vue?vue&type=script&lang=js&"
export * from "./SidenavComponent.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/perfect-scrollbar/perfect-scrollbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports